// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__YqWZB"};